/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_City_HintInputs */



/**
* | output |
* | --- |
* | "Select a country first to search for cities" |
*
* @param {User_City_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_city_hint = /** @type {((inputs?: User_City_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_City_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez d'abord un pays pour rechercher des villes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un país primero para buscar ciudades")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Selecione um país primeiro para buscar cidades")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona prima una nazione per cercare le città")
	return /** @type {LocalizedString} */ ("Select a country first to search for cities")
});